import { useAppSelector } from '@frontend/common';
import { changePage, listStore } from '@frontend/repository';
import { useSelector } from 'react-redux';
import { LoadMoreButtonProps } from './load-more-button.component';

interface ViewProps {
    isLoading: boolean;
    disabled: boolean;
    nextPage: () => void;
}

const useLoadMoreButton = (props: LoadMoreButtonProps): ViewProps => {
    const store = useAppSelector(useSelector, listStore);
    const list = store[props.listId];
    
    const nextPage = () => {
        if (!list) return;
        props.dispatch(changePage({ listId: props.listId, page: list.pageIndex + 1 }));
    };
    
    return {
        isLoading: !list || list.isLoading,
        disabled: !list || list.count === null || list.pageIndex + 1 >= Math.ceil(list.count / list.pageSize),
        nextPage
    };
};

export default useLoadMoreButton;
